import mAxios from './m-axios'

export interface Train {
  id: number
  title: string
  desc: string
  start_at: string
  end_at: string
  image: string
  location: string
  annexes: TrainAnnex[]
}

export interface TrainAnnex {
  id: number
  train_id: number
  name: string
  url: string
  suffix: string
  type: string
  sort: number
  desc:string
}

export const listTrain = (offset: number, limit: number) => {
  return mAxios({
    method: 'get',
    url: '/api/train',
    params: {
      offset: offset,
      limit: limit,
    },
  }).then(res => res.data)
}
